import * as React from 'react';
import ConnectionList from 'Edge/UI/ConnectionList';

const EdgeContents = () => {
  return <ConnectionList />;
}

export default EdgeContents;
